<template>
  <div 
    :class="{
      'colorized': isColorizedSlider, 
      'has-image': hasImage, 
      'no-head-space': answer.no_space, 
      'ec-full-with-under-image': answer.slider_full_width_under_image}" 
    class="ec-answer ec-slider" 
    @mousedown="selectAnswer($event, answer.id)">
    <span 
      v-show="effectedWarningEnabled" 
      :aria-label="this.$t('answers.change_warning_msg')"
      class="ec-answer-effected-warning-edge hint--bottom-left hint--medium">
      <i 
        class="fa fa-exclamation" 
        aria-hidden="true" />
    </span>
    <div class="ec-answer-main">
      <div 
        class="ec-answer-text" 
        v-html="answer.answer"/>
      <div class="ec-answer-input">
        <template v-if="!overrideByContactForm">
        <div 
          :style="{width: answer.slider_width + '%' }"
          class="ec-slider-wrapper">
          <input 
            :id="'slider_'+answer.id" 
            class="ec-slider-input">
        </div>
        </template>
        <div class="ec-answer-input-overlay" v-if="overrideByContactForm">
          <a href="#" @click.stop="callContactModal" class="btn is-blue" style="min-width:150px" v-text="$t('general.contact_btn')" />
        </div>
      </div>
      <div 
        class="ec-answer-text-behind" 
        v-html="answer.text_behind"/>
    </div>
    <div 
      v-if="hasImage" 
      class="ec-answer-image" 
      @click="showImage">
      <div class="ec-answer-img-wrapper">
        <div class="ec-answer-img-overlay">
          <div class="ec-img-overlay-icon"><i 
            aria-hidden="true" 
            class="fa fa-search"/></div>
        </div> 
        <img :src="imageSrc" >
      </div>
    </div>
    <AnswerDebug 
      v-if="answer.additional_informations" 
      :debug-info="answer.additional_informations"
    />
  </div>
</template>
<style>
</style>
<script>
    import { indexOf, isNull } from 'lodash'
    import Answer from './Answer.vue'

    export default {
        name: "Slider",
        extends: Answer,
        data: function() { return {
            onlyOnFirst: true,
            slider: null
        }},
        computed: {
            isColorizedSlider() {
                if(this.answer.slider_ignore_first_position_highliting && indexOf(this.answer.slider_values, this.value) === 0) {
                    return false
                }

                if(isNull(this.forceHighlighted)) {
                    if(this.isColorized) {
                        return true
                    }

                    return false
                }

                return this.forceHighlighted
            },
            disabled: function() {
                return this.$store.readOnly
            }
        },
        watch: {
            disabled: function(value) {
                this.slider.update({
                    disable: value
                })
            }
        },
        mounted() {
            this.initSlider()
        },
        methods: {
            initSlider() {
                let values = this.answer.slider_labels ? this.answer.slider_labels : this.answer.slider_values
                let fromValue = indexOf(this.answer.slider_values, this.answer.value)
                let isDisabled = this.$store.readOnly
                let self = this
               
                $("#slider_"+this.answer.id).ionRangeSlider({
                    type: "single",
                    grid: true,
                    force_edges: true,
                    values: values,
                    from: fromValue,
                    disable: isDisabled,
                    onFinish: function(data) {
                        self.value = self.answer.slider_values[data.from]
                    }
                })

                this.slider = $("#slider_"+this.answer.id).data('ionRangeSlider')

                this.$event.$on('call-change-warning-modal', () => {
                    this.slider.reset()
                })
            }
        }
    }
</script>